import * as React from "react";
import { useState, useEffect } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Stack, Button, Typography, Container, Modal } from "@mui/material";
import firebaseConfig from "../firebase";
import { collection, getDocs, doc, deleteDoc, getFirestore } from "firebase/firestore";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch } from "react-redux";
//COMPONENTs
import AnnounceUpdate from "./AnnounceUpdate";
import { useNavigate } from "react-router-dom";
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 900,
  bgcolor: 'background.paper',
  border: '2px solid #000,',
  boxShadow: 24,
  p: 4,
};
const tableText = {
  fontFamily: "Prompt",
}
function Announce() {
  const db = getFirestore(firebaseConfig)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [addModal, setAddModal] = useState(false);
  const addHandleClose = () => setAddModal(false);
  const [modal, setModal] = useState(false);
  const handleClose = () => setModal(false);
  const [item, setItem] = useState();
  const [an, setAn] = useState([]);
  const anCollectionRef = collection(db, "Announce");





  const deleteAn = async (id) => {
    const anDoc = doc(db, "Announce", id);
    await deleteDoc(anDoc);
    alert("ลบเรียบร้อย")
    window.location.reload();
  };



  useEffect(() => {
    const getAn = async () => {
      const data = await getDocs(anCollectionRef);
      setAn(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };

    getAn();
  }, []);

  return (
    <Container>
      <Typography variant="h1" sx={{ fontWeight: 'bold', fontSize: '2.25vw', marginTop: "20px", fontFamily: 'Prompt' }}>จัดการประกาศ</Typography>
      <div>
      <Button style={{ float: "right", marginBottom: 10 }} 
        sx={{ fontFamily:'Prompt'}}

        onClick={() => navigate('/announce/create')}
        variant="contained" color="success" startIcon={<AddCircleOutlineIcon/>}>เพิ่ม
        </Button>
      </div>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell sx={tableText} align="center">รูปภาพ</TableCell>
              <TableCell sx={tableText} align="center">ลิงค์</TableCell>
              <TableCell sx={tableText} align="center">สถานะ</TableCell>
              <TableCell sx={tableText} align="center">แก้ไข/ลบ</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {an.map((row) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                hover="true"
              >
                <TableCell component="th" scope="row" align="center">
                  <img src={row.announceImg} style={{ height: 150, aspectRatio: 4 / 3, width: 250 }} />
                </TableCell>
                <TableCell sx={{ fontFamily: "Prompt", }} align="center">{row.announceLink}</TableCell>
                <TableCell sx={{ fontFamily: "Prompt", }} align="center">{row.announceStatus ? <h3>เปิด</h3> : <h3>ปิด</h3>}</TableCell>
                <TableCell align="center">
                  <Stack spacing={2} direction="row" justifyContent="center" >
                    <Button
                      sx={{ fontFamily: 'Prompt' }}
                      variant="text" color="error" size="large" startIcon={<DeleteOutlineIcon />}
                      onClick={() => {
                        deleteAn(row.id);
                      }}
                    >
                      ลบ
                    </Button>
                    <Button variant="contained"
                      sx={{ fontFamily: 'Prompt' }} onClick={() => {
                        dispatch({
                          type:'announce',
                          payload:{
                            announceImg: row.announceImg,
                            announceLink: row.announceLink,
                            announceStatus: row.announceStatus,
                          }
                        })
                        navigate('/announce/update/' + row.id)
                      }} startIcon={<EditIcon />}>แก้ไข</Button>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
}

export default Announce;
